<template>
  <div class="new-upload-box">
    <div>
      <div
          class="new-upload-list"
          :style="'width:' + width + 'px;height:' + height + 'px;'"
          v-for="(item, index) in uploadList"
          :key="index"
      >
        <template v-if="item.status === 'finished'">
          <span
              class="pdf-box ellipsis"
              v-if="/(.pdf)$/i.test(item.response.data.url)"
              @click="clickFile(item.response.data.url)"
          ></span>
          <span v-else>
            <img
                :src="item.response.data.url ? item.response.data.url : item.url"
                @click="getBigPic(index)"
            />
          </span>
          <div class="upload-list-cover" v-if="!readOnly">
            <Icon type="md-remove" @click.native="handleRemove(index)"></Icon>
          </div>
          <!--          <div-->
          <!--              class="upload-hover-title"-->
          <!--              v-if="/(.pdf)$/i.test(item.response.data.url)"-->
          <!--          >-->
          <!--            {{ item.response.data.oldName }}-->
          <!--          </div>-->
          <!--          <div class="upload-hover-title" @click="getBigPic(index)" v-else>-->
          <!--            {{ item.response.data.oldName }}-->
          <!--          </div>-->
        </template>
        <template v-else>
          <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
      </div>
      <span
          class="upload-btn-box"
          :style="'width:' + width + 'px;height:' + height + 'px;'"
          v-show="uploadList.length < 1 && !readOnly"
      >
        <Upload
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :before-upload="handleBeforeUpload"
            :format="['jpg', 'jpeg', 'png', 'pdf']"
            :on-format-error="handleFormatError"
            :action="actionUrl"
            :headers="uploadHeaders"
            type="drag"
            :style="
            'display: inline-block;width:' +
            width +
            'px;height:' +
            height +
            'px;vertical-align: middle;'
          "
        >
          <div
              :style="'width:' + width + 'px;height:' + height + 'px;line-height:' + height + 'px;'"
          >
            <Icon type="md-add" size="20"></Icon>
          </div>
        </Upload>
      </span>
    </div>
    <div class="show-pic" v-if="isShowPicBox">
      <picture-viewer
          v-if="lookImageData && lookImageData.length > 0"
          :imgData="lookImageData"
          :picIndex="showPicIndex"
          @close="isShowPicBox = false"
      ></picture-viewer>
    </div>
  </div>
</template>

<script>
import auth from "@/utils/auth";
import PictureViewer from "@/components/common/PictureViewer";
import $api from "@/apiProvider";

const union = (...arr) => [...new Set(arr.flat())];
const assign = (o) => Object.assign({}, o);
const empties = [undefined, "", null, "null", {}, []];

export default {
  components: {PictureViewer},
  props: {
    isOcrDriving: {
      type: Boolean,
      default: false,
    },
    isOcrIdCard: {
      type: Boolean,
      default: false,
    },
    isOcrBusiness: {
      type: Boolean,
      default: false,
    },
    isOcrVehicle: {
      type: Boolean,
      default: false,
    },
    isFront: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 58,
    },
    height: {
      type: Number,
      default: 58,
    },
    row: {
      type: Object,
      default: null,
    },
    fileKey: {
      type: String,
      default: null,
    },
    initFile: {
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadList: [],
      defaultList: [], // 默认图片
      actionUrl: "",
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token,
      },
      isShowUploadImg: false,
      showMore: false,
      isShowPicBox: false,
      lookImageData: [],
      showPicIndex: 0,
    };
  },
  watch: {
    initFile: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.init(val);
      },
    },
  },
  mounted() {
    this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
  },
  methods: {
    init(initFile) {
      // 编辑时 设置response属性
      this.uploadList = [];
      this.defaultList = [];
      let item = {};
      if (this.uuid) {
        if (initFile && initFile.length > 0) {
          item = initFile[0];
          item.status = "finished";
          item.percentage = 100;
          if (empties.includes(item.response)) {
            item.response = {};
            item.response.data = {};

            let url = item.url ? item.url : item.response.data.url;
            let uuid = item.uuid ? item.uuid : item.response.data.uuid;
            item.response = {
              data: {
                url,
                uuid,
              },
            };
          }

          this.defaultList.push(assign(item));
        }
      } else {
        if (initFile) {
          item = {url: initFile};
          item.status = "finished";
          item.percentage = 100;
          if (empties.includes(item.response)) {
            item.response = {};
            item.response.data = {};

            let url = item.url ? item.url : item.response.data.url;
            item.response = {
              data: {
                url,
              },
            };
          }

          this.defaultList.push(assign(item));
        }
      }
      this.uploadList = union(this.uploadList, this.defaultList);
      this.returnFileUuidList();
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
            "文件 " +
            file.name +
            " 格式不正确，请上传 jpg 或 png 或 jpeg 格式的图片, .pdf 格式的文件。",
      });
    },
    handleRemove() {
      let that = this;
      this.$XModal.confirm("您确定要删除该附件吗？").then((type) => {
        if (type === "confirm") {
          that.$refs.upload.fileList.splice(0, 1);
          that.uploadList = this.$refs.upload.fileList;
          that.returnFileUuidList();
        }
      });
    },
    handleSuccess(res, file) {
      if (res && res.status === 200 && res.data) {
        if (this.isOcrVehicle) {
          this.getVehicleLicense(res.data.url);
        }
        if (this.isOcrBusiness) {
          this.getOcrBusinessLicense(res.data.url);
        }
        if (this.isOcrIdCard) {
          this.getOcrIdcardInfo(res.data.url);
        }
        if (this.isOcrDriving) {
          this.getOcrDrivingLicense(res.data.url);
        }
        this.returnFileUuidList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getOcrDrivingLicense(url) {
      let res = await $api.oss.request('getOcrDrivingLicense', {
        imageUrl: url,
        isFront: this.isFront ? 1 : 0
      });
      if (res.status === 1) {
        this.$emit('getOcrDriving', res.data);
      } else {
        this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    async getOcrIdcardInfo(url) {
      let res = await $api.oss.request('getOcrIdcardInfo', {
        imageUrl: url,
        isFront: this.isFront ? 1 : 0
      });
      if (res.status === 1) {
        this.$emit('getOcrIdCard', res.data);
      } else {
        this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    async getOcrBusinessLicense(url) {
      let res = await $api.oss.request('getOcrBusinessLicense', {
        imageUrl: url,
      });
      if (res.status === 1) {
        this.$emit('getOcrBusiness', res.data);
      } else {
        this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    async getVehicleLicense(url) {
      let res = await $api.oss.request('getVehicleLicense', {
        imageUrl: url,
        isFront: this.isFront ? 1 : 0
      });
      if (res.status === 1) {
        this.$emit('getOcrVehicle', res.data);
      } else {
        this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    handleBeforeUpload(file) {
      if (file.size > 3072000) {
        this.$XModal.alert({
          message: "单个附件大小不能超过3M，请压缩后上传",
          status: "error",
        });
        return false;
      }
      let maxFileNum = this.maxLength ? this.maxLength : 5;
      if (this.$refs.upload.fileList.length > maxFileNum) {
        this.$XModal.alert({
          message: "最多只能上传" + maxFileNum + "张",
          status: "error",
        });
        return false;
      }
      this.uploadList = this.$refs.upload.fileList;
    },
    returnFileUuidList() {
      let urlList = [];
      this.uploadList.forEach((item) => {
        if (item.response && item.response.data) {
          if (this.uuid) {
            urlList.push(item.response.data.uuid);
          } else {
            urlList.push(item.response.data.url);
          }
        } else {
          if (this.uuid) {
            urlList.push(item.uuid);
          } else {
            urlList.push(item.url);
          }
        }
      });
      this.row[this.fileKey] = urlList[0];
    },
    getBigPic() {
      this.lookImageData = [];
      this.uploadList.forEach((item, index) => {
        let regPdf = /(.pdf)$/i;
        if (!regPdf.test(item.oldName)) {
          if (item.oldName || item.response.data.oldName) {
            item.name = item.oldName || item.response.data.oldName;
          }
          item.url = item.response.data.url;
          item.bigImgUrl = item.response.data.url;
          this.lookImageData.push(item);
        }
      });
      this.isShowPicBox = true;
    },
  },
};
</script>

<style>
.add-box .vxe-table .vxe-cell .new-upload-box {
  text-indent: 0;
  padding: 5px;
}

.new-upload-list {
  display: block;
  float: left;
  background: #fff;
  border: 1px dashed #dcdee2;
  border-radius: 4px;
  /*margin-right: 3px;*/
  /*margin-bottom: 3px;*/
  line-height: 58px;
  position: relative;
}

.upload-btn-box {
  display: block;
  float: left;
}

.new-upload-list img {
  display: block;
  width: 100%;
  height: 100%;
}

.new-file-upload-box {
  display: block;
  float: left;
  width: 58px;
  height: 58px;
  border-radius: 3px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  line-height: 58px;
  text-align: center;
  margin-right: 3px;
  border: 1px dashed #dcdee2;
}

.new-upload-box .ivu-progress {
  width: 96%;
  margin: 0 auto;
  position: relative;
}

.new-upload-box .upload-btn {
  display: inline-block;
  width: 58px;
  height: 58px;
  background: #fff;
  border: 1px dashed #dcdee2;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  line-height: 58px;
  /* vertical-align: middle; */
}

.new-upload-list:hover .upload-list-cover {
  display: block;
}

.new-upload-list .upload-list-cover {
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
}

.new-upload-list .upload-list-cover i {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin: 0 auto;
  text-indent: 0;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 20px;
}

.new-upload-list .pdf-box2 {
  height: 180px;
  width: 180px;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}
</style>
